import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useMessageCount } from "./useMessageCount";

export default function NavBar({ user, onLogout }) {
  const navigate = useNavigate();
  const location = useLocation();
  const messageCount = useMessageCount();
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 900);

  useEffect(() => {
    function handleResize() { setIsMobile(window.innerWidth < 900); }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => { setMenuOpen(false); }, [location]);

  const isActive = (path) => location.pathname === path;

  const links = [
  { path: "/home", label: "Home" },
  { path: "/orders", label: "My Orders" },
  { path: "/auctions", label: "Auctions" },
  { path: "/messages", label: "Messages", badge: messageCount },
  { path: "/seller", label: "Sell" },
  { path: "/invoices", label: "Invoices" },
  { path: "/profile", label: "Profile" },
];

  const s = {
    nav: { display: "flex", justifyContent: "space-between", alignItems: "center", padding: isMobile ? "14px 20px" : "16px 40px", borderBottom: "1px solid rgba(59,130,246,0.15)", position: "sticky", top: 0, background: "rgba(238,242,251,0.95)", backdropFilter: "blur(12px)", zIndex: 200, boxShadow: "0 2px 12px rgba(59,130,246,0.08)" },
    logo: { fontSize: isMobile ? 18 : 20, fontWeight: 800, color: "#0f172a", cursor: "pointer", flexShrink: 0 },
    logoAccent: { color: "#3b82f6" },
    desktopLinks: { display: "flex", gap: 16, alignItems: "center", flexWrap: "nowrap" },
    link: (active) => ({ color: active ? "#1e40af" : "#475569", cursor: "pointer", fontSize: 14, fontWeight: active ? 700 : 500, whiteSpace: "nowrap" }),
    signOutBtn: { background: "transparent", border: "1px solid rgba(59,130,246,0.25)", color: "#475569", padding: "7px 14px", borderRadius: 8, cursor: "pointer", fontSize: 13, whiteSpace: "nowrap" },
    hamburger: { background: "transparent", border: "none", color: "#1e3a8a", fontSize: 22, cursor: "pointer", padding: 4, lineHeight: 1 },
    mobileMenu: { background: "rgba(238,242,251,0.98)", borderBottom: "1px solid rgba(59,130,246,0.12)", padding: "12px 20px", display: "flex", flexDirection: "column", gap: 2, boxShadow: "0 4px 12px rgba(59,130,246,0.08)" },
    mobileLink: (active) => ({ color: active ? "#1e40af" : "#475569", fontSize: 16, fontWeight: active ? 700 : 500, cursor: "pointer", padding: "12px 0", borderBottom: "1px solid rgba(59,130,246,0.08)", display: "flex", alignItems: "center", gap: 6 }),
    mobileSignOut: { background: "rgba(239,68,68,0.08)", color: "#ef4444", border: "1px solid rgba(239,68,68,0.2)", padding: "12px", borderRadius: 10, cursor: "pointer", fontWeight: 700, fontSize: 15, marginTop: 8, width: "100%", textAlign: "center" },
    badge: { background: "#ef4444", color: "#fff", borderRadius: 999, fontSize: 10, fontWeight: 800, padding: "2px 6px", verticalAlign: "middle", marginLeft: 4 },
  };

  return (
    <>
      <nav style={s.nav}>
        <div style={s.logo} onClick={() => navigate("/home")}>
          i<span style={s.logoAccent}>Trust Secure</span>
        </div>

        {isMobile ? (
          <button style={s.hamburger} onClick={() => setMenuOpen(o => !o)}>
            {menuOpen ? "✕" : "☰"}
          </button>
        ) : (
          <div style={s.desktopLinks}>
            {links.map(link => (
              <span key={link.path} style={s.link(isActive(link.path))} onClick={() => navigate(link.path)}>
                {link.label}
                {link.badge > 0 && <span style={s.badge}>{link.badge}</span>}
              </span>
            ))}
            <button style={s.signOutBtn} onClick={onLogout}>Sign Out</button>
          </div>
        )}
      </nav>

      {isMobile && menuOpen && (
        <div style={s.mobileMenu}>
          {links.map(link => (
            <div key={link.path} style={s.mobileLink(isActive(link.path))} onClick={() => navigate(link.path)}>
              {link.label}
              {link.badge > 0 && <span style={s.badge}>{link.badge}</span>}
            </div>
          ))}
          <button style={s.mobileSignOut} onClick={() => { setMenuOpen(false); onLogout(); }}>Sign Out</button>
        </div>
      )}
    </>
  );
}